/**
 * If question has been positively answered, go to url.
 */
function ask(question, url) {
	showConfirm({
		text: question,
		urlYes: url
	});

	return false;
    // if (confirm(question)) {
    //     document.location = url;
    // }
}

/**
 * General popup function. Popup will be centered in viewport.
 * @param url
 * @param name
 * @param width
 * @param height
 */
function popup(url, width, height, name) {
	var vWidth = $(window).width();
	var vHeight = $(window).height();

	if (typeof(width)  == 'undefined') width  = 800;
	if (typeof(height) == 'undefined') height = 600;
	if (typeof(name)   == 'undefined') name   = 'WebAdmin';

	var top  = (vHeight / 2) - (height / 2);
	var left = (vWidth / 2)  - (width / 2);

	window.open(url, name, 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',scrollbars=1,');
}


function openIframePopup(src) {
	var $modal  = $('.popup-modal');
	var $iframe = $modal.find('iframe');

	src += src.indexOf('?') >= 0 ? '&' : '?';
	src += 'popup=1';

	$iframe.off('load').on('load', function() {
		var element = this;

		setTimeout(function() {
			var height      = element.contentWindow.document.body.scrollHeight + 20;
			var maxHeight   = $(window).height() - 80;
			var hasOverflow = false;

			if (height > maxHeight) {
				height = maxHeight;
				hasOverflow = true;
			}

			$iframe.animate({
				'height': height + 'px'
			}, 300, function() {
				$modal.removeClass('loading').toggleClass('has-overflow', hasOverflow);
				$iframe.removeClass('invisible');
				$iframe.contents().find('body').css({
					'height': '100%',
					'overflow': 'auto',
					'-webkit-overflow-scrolling': 'touch'
				});
			});
		}, 200);
	});

	$modal.modal('show');
	$modal.addClass('loading');
	$iframe.addClass('invisible').css({
		'height': '150px'
	}).attr('src', src);
}


function showAlert(alert, okText) {
	var $popin = $('.alert-popin');
	var $btn   = $popin.find('.btn');

	if ($popin.is(':visible')) {
		return;
	}

	if (okText === undefined) {
		okText = $btn.data('text');
	}

	$btn.text(okText);
	$popin.find('.text').html(alert);
	$popin.modal({
		backdrop: 'static',
		keyboard: false
	});
}


function showConfirm(settings) {
	var $popin = $('.confirm-popin');

	settings = $.extend({
		text:           '',
		textYes:        $popin.find('.yes').data('text-yes'),
		textNo:         $popin.find('.yes').data('text-no'),
		urlYes:         '#',
		onConfirm:      null,
		closeOnConfirm: true,
	}, settings);

	if ($popin.is(':visible')) {
		return;
	}

	$popin.find('.text').html(settings.text);
	$popin.find('.yes').off('click').attr('href', settings.urlYes).text(settings.textYes);
	$popin.find('.no').text(settings.textNo);
	$popin.modal('show');

	$popin.find('.yes').on('click', (e) => {
		$popin.modal('hide');

		if (settings.onConfirm) {
			settings.onConfirm(e, $popin, settings);
		}
	});
}

function updateFileInputs() {
	$('.txtinput[type=file], .form-control[type=file]').each(function() {
		if ($(this).closest('.file-input').length > 0) {
			return;
		}

		$(this).wrap('<div class="file-input" />');

		var $parent = $(this).parent();

		$parent.append('<button type="button" class="btn"><i class="fa fa-file"></i> Choose file</button>');
		$parent.append('<input type="text" class="filename form-control" readonly>');

		$(this).on('change', function() {
			var file = $(this).get(0).files[0];
			$parent.find('.filename').val(file ? file.name : '');
		});
	});
}


/**
 * Get parameter value from url
 */
var QueryString = function () {
	var query_string = {};
	var query        = window.location.search.substring(1);
	var vars         = query.split("&");
	
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		
		// If first entry with this name
		if (typeof query_string[pair[0]] === "undefined") {
			query_string[pair[0]] = pair[1];
			
			// If second entry with this name
		} else if (typeof query_string[pair[0]] === "string") {
			var arr = [ query_string[pair[0]], pair[1] ];
			query_string[pair[0]] = arr;
			
			// If third or later entry with this name
		} else {
			query_string[pair[0]].push(pair[1]);
		}
	}
	
	return query_string;
} ();


/**
 * The equivalent of PHP's mktime function.
 * Usage: mktime( [ int hour [, int minute [, int second [, int month [, int day [, int year [, int is_dst]]]]]]] )
 */
function mktime() {
    var no=0, i = 0, ma=0, mb=0, d = new Date(), dn = new Date(), argv = arguments, argc = argv.length;
 
    var dateManip = {
        0: function(tt){ return d.setHours(tt); },
        1: function(tt){ return d.setMinutes(tt); },
        2: function(tt){ var set = d.setSeconds(tt); mb = d.getDate() - dn.getDate(); return set; },
        3: function(tt){ var set = d.setMonth(parseInt(tt, 10)-1); ma = d.getFullYear() - dn.getFullYear(); return set; },
        4: function(tt){ return d.setDate(tt+mb); },
        5: function(tt){
            if (tt >= 0 && tt <= 69) {
                tt += 2000;
            }
            else if (tt >= 70 && tt <= 100) {
                tt += 1900;
            }
            return d.setFullYear(tt+ma);
        }
        // 7th argument (for DST) is deprecated
    };
 
    for( i = 0; i < argc; i++ ){
        no = parseInt(argv[i]*1, 10);
        if (isNaN(no)) {
            return false;
        } else {
            // arg is number, let's manipulate date object
            if(!dateManip[i](no)){
                // failed
                return false;
            }
        }
    }
    for (i = argc; i < 6; i++) {
        switch(i) {
            case 0:
                no = dn.getHours();
                break;
            case 1:
                no = dn.getMinutes();
                break;
            case 2:
                no = dn.getSeconds();
                break;
            case 3:
                no = dn.getMonth()+1;
                break;
            case 4:
                no = dn.getDate();
                break;
            case 5:
                no = dn.getFullYear();
                break;
        }
        dateManip[i](no);
    }
 
    return Math.floor(d.getTime()/1000);
}


/**
 * This dump function is useful to print arrays and objects for
 * debugging purposes.
 */
function dump(arr,level) {
    var dumped_text = "";
    if(!level) level = 0;
    
    //The padding given at the beginning of the line.
    var level_padding = "";
    
    for(var j=0;j<level+1;j++) {
        level_padding += "    ";
    }
    
    if(typeof(arr) == 'object') { //Array/Hashes/Objects
        for(var item in arr) {
            var value = arr[item];

            if(typeof(value) == 'object') { //If it is an array,
                dumped_text += level_padding + "'" + item + "' ...\n";
                dumped_text += dump(value,level+1);
            } else {
                dumped_text += level_padding + "'" + item + "' => \"" + value + "\"\n";
            }
        }
    } else { //Stings/Chars/Numbers etc.
        dumped_text = "===>"+arr+"<===("+typeof(arr)+")";
    }
    
    return dumped_text;
}


function addslashes(str) {
	str=str.replace(/\\/g,'\\\\');
	str=str.replace(/\'/g,'\\\'');
	str=str.replace(/\"/g,'\\"');
	str=str.replace(/\0/g,'\\0');
	
	return str;
}

function stripslashes(str) {
	str=str.replace(/\\'/g,'\'');
	str=str.replace(/\\"/g,'"');
	str=str.replace(/\\0/g,'\0');
	str=str.replace(/\\\\/g,'\\');
	
	return str;
}

function keepAlive(keepalive_url) {
	$.ajax({url: keepalive_url, success: function(data) {
		//alert(data);
	}});
}
